import Vue from 'vue';
import AxiosService from './../services/AxiosService';
export default async function initializeApplication(): Promise<number> {
  const axios = new AxiosService();

  const config = await axios.axiosInstance.get('api/cnf');
  const usr = await axios.axiosInstance.get('api/UserInfo');

  Vue.prototype.$appConfig = config.data;
  Vue.prototype.$user = usr.data;

  const p = Promise.resolve(1);
  return p;
}
